module.exports = __webpack_public_path__ + "media/corporate-image/mail-icon-white-5c43c8bf6c147a18ead60b6411ba6022.png";